export default __webpack_public_path__ + "static/brick-display-pro-black-8b12dbb610ad95b20b83d7d52af462b1.woff";